export default {
  baseStyle: {
    maxWidth: '100%',
  },
}
